var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.source.isLetter
      ? _c(
          "strong",
          {
            staticClass: "alphabetical-list__results__separator",
            attrs: { id: _vm.source.id, tabindex: "-1" },
          },
          [
            _c(
              "span",
              { staticClass: "alphabetical-list__results__separator__bg" },
              [_vm._v(_vm._s(_vm.source.title))]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.source.isLetter
      ? _c(
          "a",
          {
            staticClass: "alphabetical-list__results__item",
            attrs: {
              href: _vm.source.links.length ? _vm.source.links[0].url : "#",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.bus.$emit("handle-virtual-scroll-list-item-click", {
                  source: _vm.source,
                  event: $event,
                })
              },
            },
          },
          [
            _c("span", {
              staticClass: "alphabetical-list__results__title",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$options.filters.mark(_vm.source.title, _vm.searchTerm)
                ),
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "alphabetical-list__results__desc",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$options.filters.mark(_vm.source.desc, _vm.searchTerm)
                ),
              },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }